import { type UseQueryResult, useQuery } from 'react-query';
import {
  RsuAwardService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_RsuAwardListDto,
} from '@wealthlane/api-services/wealthlane-award-service';
// import { ParticipantService } from '@wealthlane/api-services/wealthlane-customer-service';
import { type TableParamsType } from '../../types/common';

const useGetRsuParticipantList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  filterData: TableParamsType,
  tableInfo: TableParamsType & {
    awardTypeFilter?: string;
    fromApproveDate?: string;
    toApproveDate?: string;
    fromPublishDate?: string;
    toPublishDate?: string;
  },
  enabled?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_RsuAwardListDto | undefined,
  unknown
> => {
  // const {
  //   approvalStatusId,
  //   optionAcceptance: rsuAcceptance,
  //   fromDate,
  //   toDate,
  //   createdFromDate,
  //   createdToDate,
  //   employeeStatusId,
  //   grantFromDate,
  //   grantToDate,
  // } = filterData;

  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    approvalStatusId,
    optionAcceptance: rsuAcceptance,
    fromDate,
    toDate,
    createdFromDate,
    createdToDate,
    employeeStatusId,
    grantFromDate,
    grantToDate,
    fromApproveDate,
    toApproveDate,
    fromPublishDate,
    toPublishDate,
    awardTypeFilter,
    _force,
  } = tableInfo;
  const rsuStatus = 0;

  const RsuParticipantList = useQuery(
    [
      'getRsuParticipantList',
      approvalStatusId,
      fromDate,
      toDate,
      employeeStatusId,
      rsuStatus,
      rsuAcceptance,
      createdFromDate,
      createdToDate,
      grantFromDate,
      grantToDate,
      awardTypeFilter,
      fromApproveDate,
      toApproveDate,
      fromPublishDate,
      toPublishDate,
      awardTypeFilter,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        RsuAwardService.getApiAwardApiAppRSUAwardRSUAwardList(
          approvalStatusId ?? [0],
          employeeStatusId ?? [0],
          rsuStatus,
          rsuAcceptance,
          createdFromDate,
          createdToDate,
          grantFromDate,
          grantToDate,
          awardTypeFilter,
          fromApproveDate,
          toApproveDate,
          fromPublishDate,
          toPublishDate,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    },
    {
      enabled: enabled !== false,
    }
  );
  return RsuParticipantList;
};

export default useGetRsuParticipantList;
